(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offers-eligibility-banner"] && !Shopify.designMode) return;
  try {
    class OffersEligibilityManager extends HTMLElement {
    constructor() {
      super();
      this.isProcessing = false;
      this.bannerText = null;
      this.loader = null;
      this.checkoutButton = null;
    }

    connectedCallback() {
      // Trouver les éléments
      this.bannerText = this.querySelector('.offers-eligibility-banner__text');
      this.loader = this.querySelector('.offers-loader');
      this.checkoutButton = document.getElementById('checkout');

      // Vérifier et retirer les produits offerts sans promotion au chargement
      this.checkAndRemoveItemsWithoutDiscount();
    }

    showLoader() {
      if (this.bannerText) {
        this.bannerText.style.display = 'none';
      }
      if (this.loader) {
        this.loader.style.display = 'block';
      }
      if (this.checkoutButton) {
        this.checkoutButton.disabled = true;
        this.checkoutButton.setAttribute('aria-disabled', 'true');
      }
    }

    hideLoader() {
      if (this.bannerText) {
        this.bannerText.style.display = 'block';
      }
      if (this.loader) {
        this.loader.style.display = 'none';
      }
      if (this.checkoutButton) {
        this.checkoutButton.disabled = false;
        this.checkoutButton.removeAttribute('aria-disabled');
      }
    }

    async checkAndRemoveItemsWithoutDiscount() {
      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      this.showLoader();

      try {
        // Récupérer le panier actuel
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) {
          throw new Error('Failed to fetch cart');
        }
        const cart = await cartResponse.json();

        // Trouver les produits avec _offer_id mais sans promotion appliquée
        const itemsToRemove = [];

        for (const item of cart.items) {
          // Vérifier si l'item a l'attribut _offer_id
          const offerAttribute = item.properties?.['_offer_id'];
          if (!offerAttribute) {
            continue;
          }

          // Vérifier si l'item a une promotion/discount appliquée
          // Si le prix final est égal au prix original, pas de promotion
          const hasDiscount =
            item.final_line_price < item.original_line_price ||
            (item.discounts && item.discounts.length > 0) ||
            item.total_discount > 0;

          if (!hasDiscount) {
            // Le produit a _offer_id mais pas de promotion, il doit être retiré
            itemsToRemove.push({
              id: item.key,
              quantity: 0, // 0 = supprimer complètement
            });
          }
        }

        // Retirer les produits sans promotion
        if (itemsToRemove.length > 0) {
          await this.removeItemsFromCart(itemsToRemove);

          // Recharger la page pour mettre à jour l'affichage
          window.location.reload();
        } else {
          // Aucun produit à retirer, masquer le loader
          this.hideLoader();
        }
      } catch (error) {
        console.error('Error removing items without discount:', error);
        this.hideLoader();
      } finally {
        this.isProcessing = false;
      }
    }

    async removeItemsFromCart(itemsToRemove) {
      const updates = {};
      for (const item of itemsToRemove) {
        updates[item.id] = item.quantity;
      }

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }
    }
  }

  customElements.define('offers-eligibility-manager', OffersEligibilityManager);
  } catch(e) { console.error(e); }
})();

})();
